import type { TBenefitType } from '@model/Candidate/Candidate.type';
import { BENEFIT_TYPES } from '@model/Candidate/constants/types.constants';
import { ICON_NAMES, TIconName } from '@reverse-hr/design-system';
import type { ObjectValues } from '@utils/types/ObjectValues';

export const SORTED_BENEFIT_TYPES: TBenefitType[] = [
  BENEFIT_TYPES.MILEAGE_REIMBURSEMENT,
  BENEFIT_TYPES.TRAVEL_ALLOWANCE,
  BENEFIT_TYPES.WELFARE,
  BENEFIT_TYPES.CAR,
  BENEFIT_TYPES.INSURANCE,
  BENEFIT_TYPES.PENSION_FUND,
  BENEFIT_TYPES.TRAINING,
  BENEFIT_TYPES.DEVICES,
  BENEFIT_TYPES.FOOD,
  BENEFIT_TYPES.STOCKS,
  BENEFIT_TYPES.ACCOMMODATION,
  BENEFIT_TYPES.REMOTE_WORKING,
  BENEFIT_TYPES.OTHER,
];

export const DETAILS_ITEMS_TYPES = {
  ...BENEFIT_TYPES,
  RAL: 'ral',
  BONUSES_AND_BENEFITS: 'bonuses_and_benefits',
};

export const DETAILS_ITEMS_TYPES_TO_ICONS_MAP: Record<
  ObjectValues<typeof DETAILS_ITEMS_TYPES>,
  TIconName
> = {
  [DETAILS_ITEMS_TYPES.ACCOMMODATION]: ICON_NAMES.LOCATION_OUTLINE,
  [DETAILS_ITEMS_TYPES.BONUSES_AND_BENEFITS]: ICON_NAMES.TROPHY,
  [DETAILS_ITEMS_TYPES.CAR]: ICON_NAMES.CAR,
  [DETAILS_ITEMS_TYPES.DEVICES]: ICON_NAMES.DEVICES,
  [DETAILS_ITEMS_TYPES.FOOD]: ICON_NAMES.RESTAURANT,
  [DETAILS_ITEMS_TYPES.INSURANCE]: ICON_NAMES.USER_HEART,
  [DETAILS_ITEMS_TYPES.MILEAGE_REIMBURSEMENT]: ICON_NAMES.ROAD,
  [DETAILS_ITEMS_TYPES.OTHER]: ICON_NAMES.STAR,
  [DETAILS_ITEMS_TYPES.PENSION_FUND]: ICON_NAMES.ACCOUNT_BALANCE,
  [DETAILS_ITEMS_TYPES.RAL]: ICON_NAMES.PAYMENTS,
  [DETAILS_ITEMS_TYPES.REMOTE_WORKING]: ICON_NAMES.HOME_OUTLINE,
  [DETAILS_ITEMS_TYPES.STOCKS]: ICON_NAMES.LINE_CHART_UP,
  [DETAILS_ITEMS_TYPES.TRAINING]: ICON_NAMES.GRADUATION,
  [DETAILS_ITEMS_TYPES.TRAVEL_ALLOWANCE]: ICON_NAMES.CREDIT_CARD_HEART,
  [DETAILS_ITEMS_TYPES.WELFARE]: ICON_NAMES.HOME_HEART,
};
